// test790
(790 && 0);
